export default __webpack_public_path__ + "static/media/sx.e6fc24ce.svg";